// extracted by mini-css-extract-plugin
export default {"link":"ModalNotify_link__rWqUH"};